import { IShipping } from '@/models'
import { api } from '@/api/api'

export async function fetchShipping(shippingID: string): Promise<IShipping> {
    const { data: shipping } = await api.get(`shipping/get/${shippingID}`)

    return shipping
}
